import { gql } from "@apollo/client";

export const LIST_HOMEOWNER_CLIENTS = gql`
  query ListHomeownerClients($first: Int, $after: String) {
    listHomeowners(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          userId
          firstName
          lastName
          email
          phoneNumber
          createdAt
          clientProfile {
            id
            ownerType
            createdAt
          }
        }
      }
    }
  }
`;

export const GET_HOMEOWNER_CLIENT = gql`
  query GetHomeownerClient($id: String!) {
    homeowner(id: $id) {
      id
      userId
      firstName
      lastName
      email
      phoneNumber
      createdAt
      updatedAt
      clientProfile {
        id
        ownerType
        createdAt
        updatedAt
      }
      billingAddress {
        id
        address
        city
        state
        formattedAddress
      }
      addresses {
        id
        address
        city
        state
        formattedAddress
      }
    }
  }
`;

export const LIST_ORGANISATION_CLIENT_PROFILES = gql`
  query ListOrganisationClientProfiles($first: Int, $after: String) {
    organizationClientProfiles(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          contactName
          contactEmail
          contactPhoneNumber
          billingName
          createdAt
          organization {
            id
            name
          }
          clientProfile {
            id
            ownerType
            createdAt
          }
        }
      }
    }
  }
`;

export const GET_ORGANISATION_CLIENT_PROFILE = gql`
  query GetOrganisationClientProfile($id: String!) {
    organizationClientProfile(id: $id) {
      id
      contactUserId
      contactName
      contactEmail
      contactPhoneNumber
      billingName
      createdAt
      updatedAt
      organization {
        id
        name
        referralCode
        countryCode
        createdAt
      }
      clientProfile {
        id
        ownerType
        createdAt
        updatedAt
      }
      legacyClient {
        id
        userId
        firstName
        lastName
        email
        phoneNumber
      }
      billingAddress {
        id
        address
        city
        state
        formattedAddress
      }
      facilities {
        id
        name
        address {
          id
          formattedAddress
        }
        contacts {
          id
          name
          email
          phoneNumber
        }
      }
    }
  }
`;

export const ADMIN_GET_ORGANISATION_WALLET_BALANCE = gql`
  query AdminOrganisationWalletBalance($organizationId: String!) {
    adminOrganizationWalletBalance(organizationId: $organizationId)
  }
`;

export const ADMIN_GET_ORGANISATION_WALLET_LEDGER_HISTORY = gql`
  query AdminOrganisationWalletLedgerHistory(
    $organizationId: String!
    $first: Int
    $after: String
  ) {
    adminOrganizationWalletLedgerHistory(
      organizationId: $organizationId
      first: $first
      after: $after
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          amount
          type
          transactionType
          description
          createdAt
          initiatedBy {
            id
            name
            email
          }
        }
      }
    }
  }
`;

export const ADMIN_CREATE_ORGANISATION_FACILITY = gql`
  mutation AdminCreateOrganisationFacility(
    $organizationId: String!
    $payload: CreateOrganizationFacilityInput!
  ) {
    adminCreateOrganizationFacility(
      organizationId: $organizationId
      payload: $payload
    ) {
      id
      name
      address {
        id
        formattedAddress
      }
      contacts {
        id
        name
        email
        phoneNumber
      }
    }
  }
`;

export const ADMIN_UPDATE_ORGANISATION_FACILITY = gql`
  mutation AdminUpdateOrganisationFacility(
    $facilityId: String!
    $payload: UpdateOrganizationFacilityInput!
  ) {
    adminUpdateOrganizationFacility(
      facilityId: $facilityId
      payload: $payload
    ) {
      id
      name
      address {
        id
        formattedAddress
      }
    }
  }
`;

export const ADMIN_ADD_ORGANISATION_FACILITY_CONTACT = gql`
  mutation AdminAddOrganisationFacilityContact(
    $payload: AddOrganizationFacilityContactInput!
  ) {
    adminAddOrganizationFacilityContact(payload: $payload) {
      id
      name
      email
      phoneNumber
    }
  }
`;

export const ADMIN_UPDATE_ORGANISATION_FACILITY_CONTACT = gql`
  mutation AdminUpdateOrganisationFacilityContact(
    $contactId: String!
    $payload: UpdateOrganizationFacilityContactInput!
  ) {
    adminUpdateOrganizationFacilityContact(
      contactId: $contactId
      payload: $payload
    ) {
      id
      name
      email
      phoneNumber
    }
  }
`;
